var map = {
	"./locum/image1.png": 61491,
	"./locum/image2.png": 93061,
	"./locum/image3.png": 60623,
	"./locum/image4.png": 61566,
	"./pharmacy/image1.png": 60626,
	"./pharmacy/image2.png": 83359,
	"./pharmacy/image3.png": 38633,
	"./pharmacy/image4.png": 98483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9409;